import { useDataSubmit } from 'Simple/Data'

export function useOnClick(props) {
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'treatment',
  })

  return function onClick() {
    submit({
      type: 'remove_financial_contract_setup',
    })
  }
}
